export default "__VITE_ASSET__BBwznjCJ__"